import {useDataProvider} from "./base-data.provider";
import {useCallback} from "react";

export function useQuizAssessmentAvailabilityDataProvider() {
  const { request } = useDataProvider();

  const findAvailability = useCallback((id) => {
    return request({
      method: "GET",
      path: `/quiz-assessment-availability/${id}`,
    })
  }, [request]);

  const listClassesRelated = useCallback(() => {
    return request({
      method: "GET",
      path: "/quiz-assessment-availability/classes",
    })
  }, [request]);

  const listAcademicPeriodsRelated = useCallback(() => {
    return request({
      method: "GET",
      path: "/quiz-assessment-availability/academic-periods",
    })
  }, [request]);

  const listAvailabilityResults = useCallback(() => {
    return request({
      method: "GET",
      path: "/quiz-assessment-availability/results",
    })
  }, [request]);

  const listAvailabilityResultItem = useCallback((availabilityId) => {
    return request({
      method: "GET",
      path: "/quiz-assessment-availability/result-item/" + availabilityId,
    })
  }, [request]);

  const listAvailableTests = useCallback(() => {
    return request({
      method: "GET",
      path: "/quiz-assessment-availability/available-tests",
    })
  }, [request]);

  const getSummary = useCallback((assessmentType, classId, academicPeriodId) => {
    return request({
      method: "GET",
      path: "/quiz-assessment-availability/summary",
      query: { assessmentType, classId, academicPeriodId }
    })
  }, [request]);


  const getStudentsStats = useCallback((assessmentType, classId, academicPeriodId) => {
    return request({
      method: "GET",
      path: "/quiz-assessment-availability/students-stats",
      query: { assessmentType, classId, academicPeriodId }
    })
  }, [request]);

  return {
    listClassesRelated,
    listAvailabilityResults,
    listAvailabilityResultItem,
    findAvailability,
    listAcademicPeriodsRelated,
    listAvailableTests,
    getStudentsStats,
    getSummary
  }
}
